import React from "react";
import axios from "axios";
import { BrowserRouter } from 'react-router-dom';

axios.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("user");
    if (raw) {
      const u = JSON.parse(raw);
      if (u && u.token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${u.token}`;
      }
    }
  } catch (e) {
    // ignore invalid JSON in storage (heee this is nothing)
  }
  return config;
});
import ReactDOM from 'react-dom/client';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import { base_path } from "./environment.jsx";
import './style/css/feather.css'
import './style/css/line-awesome.min.css'
import "./style/scss/main.scss";
import './style/icons/fontawesome/css/fontawesome.min.css'
import './style/icons/fontawesome/css/all.min.css'


import { Provider } from "react-redux";
import store from "./core/redux/store.jsx";
import AllRoutes from "./Router/router.jsx";
import { AuthProvider } from "./core/context/AuthContext.jsx";

const rootElement = document.getElementById('root');



if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
    <Provider store={store} >
      <AuthProvider>
      <BrowserRouter basename={base_path}>
      <AllRoutes />

      </BrowserRouter>
      </AuthProvider>
    </Provider>
  </React.StrictMode>
  );
} else {
  console.error("Element with id 'root' not found.");
}
